import { categoryNavigationQuery, departmentFromPath } from './plpNavigation';
import { queryStr } from './plp';

export function manufacturerAutoSelectTarget(
    item: { categoryPath?: string },
    seoUrl: string | undefined,
    route: { path: string; query: Record<string, any> },
    keepFilters: boolean,
) {
    if (seoUrl) {
        const path = '/' + seoUrl.replace(/^\//, '');
        if (path.replace(/\/$/, '') === route.path.replace(/\/$/, '')) return undefined;
        return keepFilters ? {
            path,
            query: categoryNavigationQuery(route.query, {}, departmentFromPath(route.path), departmentFromPath(path)),
        } : path;
    }

    // Department nodes such as Dames/Heren often have no brand-specific SEO URL.
    // Follow their full Tweakwise path, exactly as a manual category selection does.
    if (!item.categoryPath || item.categoryPath === queryStr(route.query.tn_cid)) return undefined;
    return { path: route.path, query: { ...route.query, tn_cid: item.categoryPath, variant: undefined, p: '1' } };
}
